import { render, staticRenderFns } from "./BatchStatus.vue?vue&type=template&id=61551ffe&"
import script from "./BatchStatus.js?vue&type=script&lang=js&"
export * from "./BatchStatus.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports